import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-servicepartnarpopup',
  templateUrl: './servicepartnarpopup.component.html',
  styleUrls: ['./servicepartnarpopup.component.css']
})
export class ServicepartnarpopupComponent implements OnInit {
  @Input() partnerInfo: any;
  staffData = {
    serviceType: '',
    organisationName: '',
    contactPerson: '',
    mobileNumber: '',
    emailId: '',
    city:'',
    securityDeposit:'',
    date:''
  };


  submitForm() {
    this.activeModal.close(this.staffData);
  }
  onClose(): void {
    this.activeModal.dismiss('Modal closed'); 
  }
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if(this.partnerInfo) {
      this.staffData = this.partnerInfo
    }
  }

}
